import { useEffect, useState } from "react"
import { RequestConfigs } from "../../api"
import { useFormHandling } from "../../hooks/formUtils"
import { Link } from "react-router-dom"
import { Col, DotListItem, ListItem, Row, Toggle } from "../../style/base.style"
import styled from "styled-components"
import { translate } from "react-range/lib/utils"
import { useDictionary } from "../../contexts/dictionary"
import { useContactType } from "../../contexts/ContactContext"
import { ProfileImg } from "../common/profileImage"
import { calculateAge } from "../../utils/calculators"
import { PopupLayout } from "../common/popup"
import { FieldType, TextFieldType } from "../fields"
import Joi from "joi"
import { FormComponent } from "../form"
import { DateTimePickerType } from "../fields/DatePicker"
import { ActionButton } from "../buttons/ActionButton"
import { id } from "date-fns/locale"
import { Colors } from "../../style/colors"

interface FamilyProps {
  minimize?:boolean
}

export const Family = ({minimize}:FamilyProps) => {
    const {family,contact} = useContactType()

    const [memberIsActive,setMemberIsActive] = useState<boolean>(false)
    
    const {translate} = useDictionary()

    const getFamilyRole = (familyMember:FamilyMember) => {
        if(familyMember.family__Is_Guardian && !contact?.family__Is_Guardian){
            if(familyMember.Salutation==="Mr."){
                return translate('father')
            } else {
                return translate('mother')
            }
        } else if(familyMember.family__Is_Guardian && contact?.family__Is_Guardian){
            if(familyMember.Salutation==="Mr."){
                return translate('spouse')
            } else {
                return translate('spouse')
            }

        } else if (!familyMember.family__Is_Guardian && contact?.family__Is_Guardian){
            if(familyMember.Salutation==='Master.'){
                return translate('son')
            } else {
                return translate('daughter')
            }

        } else {
            if(familyMember.Salutation==='Master.'){
                return translate('brother')
            } else {
                return translate('sister')
            }
        }
    }

    const calcAge = (date?:Date | string | null) => {
        const age = calculateAge(date)
        return age
    }
    

  

    const showFamily = family && family?.length > 0

    const [openPopup,setOpenPopup] = useState<number>(-1)

    const closePopup = () => {
      setOpenPopup(-1)
    }

    const openPopupAction = (index:number) => {
      console.log('openPopupAction',index)
      setOpenPopup(index)
    }
    console.log('family',family)
    return (
        <>
        
            <table className="table dashboard-table" style={{ borderSpacing: '0 5px',  borderCollapse: 'separate' }}>
                <tbody >
                    { showFamily &&
                        family?.map((familyMember, index) => (
                          
                            <Row  $width="100%" $justifyContent="space-between" $alignItems="center" key={index} $padding="5px" $gap={10} style={{borderRadius: '10px',border: `1px solid ${Colors.fieldBorder}`, margin:'5px'}}>
                              <EditPopup member={familyMember} isOpen={openPopup===index} onClose={()=>closePopup()}/>
                         
                              <Row $width={minimize?"100%":"65%"} $justifyContent="flex-start" $alignItems="center" $gap={10} $backgroundColor="blue">
                              <Col>
                                <ProfileImg width={40} height={40} contact={familyMember}/>
                              </Col>
                              
                               <Col $alignItems="flex-start">
                               
                                  <h5>{familyMember.Full_Name}</h5>
                                  <Row $width="100%" $justifyContent="flex-start" $alignItems="center" $gap={10}>
                                  <ul style={{display:'flex', gap:10}}>
                                    <DotListItem>{getFamilyRole(familyMember)}</DotListItem>
                                    {
                                      !minimize &&
                                    <>
                                      {/* <DotListItem>{translate(['Miss.','Mrs.'].includes(familyMember?.Salutation || "")?'female':'male')}</DotListItem> */}
                                      <DotListItem>  {`${translate(['Miss.','Mrs.'].includes(familyMember?.Salutation || "")?'girl':'boy')} ${calcAge(familyMember.Date_of_Birth)?.years} ${translate('and')}${calcAge(familyMember.Date_of_Birth)?.months} ${translate('months')} `}</DotListItem>
                                    </>
                                    }
                                  </ul>
                                  </Row>
                                  
                                  </Col>
                              </Row>
                            
                            {
                              !minimize &&
                              <Row $width="25%" $justifyContent="flex-end" $alignItems="center" $gap={10}>
   
                              
                                {/* <span className="deactive">{translate('activate')}</span>
                                
                                <Toggle $isActive={memberIsActive} onClick={()=>setMemberIsActive(prev=>!prev)} />

                                <span className="active">{translate('deactivate')}</span> */}
                             
                              <Link
                                onClick={()=>openPopupAction(index)}
                                to="#"
                                className="edit-icon"
                             
                              >
                                <i className="fa-solid fa-pen-to-square" />
                              </Link>
                            

                              </Row>
                       
                            }
                          
                            
                          </Row>
                        ))
                    }
                    {
                        !showFamily && 
                        <>
                        <Col $width="100%" $alignItems="center" $justifyContent="center" $padding="50px">
                            <h3>{translate('no_family_members')}</h3>
                        </Col>
                        </>
                    }

                </tbody>
            </table>
        </>
    )
}

interface EditMemberPopup {
  isOpen:boolean
  onClose:()=>void
  member:FamilyMember
}
const EditPopup = ({isOpen,onClose,member}:EditMemberPopup) => {

  const {translate} = useDictionary()

  const {handleClick,handleInputChange,serverRes} = useFormHandling({requestType:RequestConfigs.updateFamilyMember,data:{id:member.id}})

  useEffect(() => {
    if(serverRes){
      if(serverRes.succeeded){
        onClose()
      }
    }
  }, [serverRes]);

  const formFields:FieldConfig[] = [
      {
        type: FieldType.text,
        name: "Full_Name",
        label: translate("name"),
        joiSchema: Joi.string().pattern(/^\s*\S+\s+\S+\s*$/).message('Must contain exactly two words').required(),
        defaultValue: member?.Full_Name,
        readonly: member.family__Is_Guardian,
        typeOptions: {
          type: TextFieldType.text,
        }
      },
      {
        type: FieldType.text,
        name: "Phone",
        label: translate("phone_label"),
        defaultValue: member?.Phone,
        readonly: member.family__Is_Guardian,
        joiSchema: Joi.string().length(10).required(),
        typeOptions: {
          type: TextFieldType.text,
        }
      },
      {
        type: FieldType.text,
        name: "Email",
        label: translate("email_label"),
        defaultValue: member?.Email,
        readonly: member.family__Is_Guardian,
        joiSchema: Joi.string().email({ tlds: { allow: false } }).required(),
        typeOptions: {
          type: TextFieldType.text,
        }
      },
      {
        type: FieldType.text,
        name: "payments0__Gov_Id",
        label: translate("id"),
        defaultValue: member?.payments0__Gov_Id,
        joiSchema: Joi.string().required(),
        typeOptions: {
          type: TextFieldType.text,
        }
      },
      {
        type: FieldType.dateTime,
        name: "Date_of_Birth",
        label: translate("dob"),
        defaultValue: member?.Date_of_Birth,
        joiSchema: Joi.string().required(),
        typeOptions: {
          dateType: DateTimePickerType.date,
        }
      },
      {
        type: FieldType.select,
        name: "Salutation",
        label: translate("gender"),
        defaultValue: member?.Salutation,
        joiSchema: Joi.string().required(),
        typeOptions: {
          options: [
            {
              value:'Mr.',
              label:translate('male')  
            },
            {
              value:'Mrs.',
              label:translate('female')  
            },
            {
              value:'Master.',
              label:translate('female')  
            },
            {
              value:'Miss.',
              label:translate('female')  
            }
          ],
        }
      },
  
  
   ]
  return (
<PopupLayout isOpen={isOpen} onClose={onClose} title="Edit Family Member">
  <FormComponent
  fields={formFields}
  onChange={handleInputChange}
  />
  <ActionButton width="100%" label="Save" onClick={handleClick}/>

</PopupLayout>
  )

  
}


const Td = styled.td`
    width: 100%;
    /* border-radius: 10px; */
    cursor: pointer;

`